import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Menu, MenuItem, IconButton, ListItemIcon, Switch, ListItemText, Avatar } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PersonIcon from '@material-ui/icons/Person';
import HelpIcon from '@material-ui/icons/Help';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';
import customConfig from '../../config';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { connect, useSelector } from 'react-redux';

const UserProfileMenu = ({ logout, username }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const initials = username
    ? username
        .split(/[.\s]/)         
        .map((word) => word[0])
        .join('')
        .toUpperCase()
    : 'O';




  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
const history = useHistory();
  const handleViewProfile = () => {
    handleMenuClose();
    history.push('/profile'); 
  };

  const handleSupport = () => {
    handleMenuClose();
    window.open(customConfig.supportURL, '_blank');
  };

  const handleSettings = () => {
    return <Redirect to="/Settings" />;
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
  };

  return (
    <div className='profile-icon'>
      <IconButton onClick={handleMenuOpen} style={{ color: 'white', backgroundColor: 'transparent' }}>
      <Avatar
          style={{
            backgroundColor: 'white', 
            color: 'black',          
            fontWeight: 'bold',       
          }}
        >
          {initials}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
         {/* <MenuItem onClick={handleViewProfile}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          View Profile
        </MenuItem>  */}

        <MenuItem onClick={handleSupport}>
          <ListItemIcon>
            <HelpIcon fontSize="small" />
          </ListItemIcon>
          Support
        </MenuItem>
        <Link to="/Settings" style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleMenuClose}>
          <MenuItem>
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
        </Link>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <ExitToAppIcon fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

const mapStateToProps = (state) => ({
  username: state.auth.username,
});

export default connect(mapStateToProps,null)(UserProfileMenu);